import React, { useState, useRef } from "react";
import { Box, Typography } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { toast } from "react-toastify";

function CommonFileUploader({
  accept = ".csv",
  maxSize = 50 * 1024 * 1024, // 50MB default
  label = "CSV File (max. 50MB)",
  multiple = false,
  onFileSelect,
  disabled = false,
}) {
  const [file, setFile] = useState(null);
  const fileInputRef = useRef();

  //Validate file type & size
  const validateFile = (selectedFile) => {
    if (!selectedFile) return false;

    const allowedExtensions = accept
      .split(",")
      .map((ext) => ext.trim().toLowerCase());

    const fileName = selectedFile.name.toLowerCase();
    const isValidExtension = allowedExtensions.some((ext) =>
      fileName.endsWith(ext.replace(".", ""))
        ? fileName.endsWith(ext)
        : selectedFile.type.includes(ext)
    );

    if (!isValidExtension) {
      toast.error(`Invalid file format. Only ${accept} files are allowed.`);
      return false;
    }

    if (selectedFile.size > maxSize) {
      toast.error(
        `File is too large (max ${Math.round(maxSize / 1024 / 1024)}MB).`
      );
      return false;
    }

    return true;
  };

 
 const handleFileChange = (event) => {
  const selectedFile = event.target.files[0];

  // Reset input so same file can be selected again
  event.target.value = "";

  if (validateFile(selectedFile)) {
    setFile(selectedFile);
    onFileSelect?.(selectedFile);
  }
};

   const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (validateFile(droppedFile)) {
      setFile(droppedFile);
      onFileSelect?.(droppedFile);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const openFileDialog = () => {
    if (!disabled) fileInputRef.current.click();
  };

  return (
    <Box
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={openFileDialog}
      sx={{
        border: "1px dashed #ccc",
        borderRadius: "8px",
        p: 5,
        textAlign: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "border-color 0.2s",
        "&:hover": {
          borderColor: "primary.main",
          backgroundColor: disabled ? "transparent" : "#F7F6FF",
        },
      }}
    >
      <input
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={handleFileChange}
        ref={fileInputRef}
        style={{ display: "none" }}
        disabled={disabled}
      />

      <UploadFileIcon sx={{ fontSize: 34, color: "text.secondary", mb: 1 }} />

      <Typography variant="body1">
        <Typography component="span" color="primary" fontWeight={500}>
          Upload
        </Typography>{" "}
        or drag and drop
      </Typography>

      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

export default CommonFileUploader;
